export const TOOL_TASK = 'unassign-users-entitlements';
export const TOOL_TITLE = 'Unassign Entitlements From Users';
export const TOOL_PROGRESS_LABEL = 'Progress of unassigning entitlements from users...';
export const FILE_NAME = 'Unassign-entitlements-from-users-report';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once unassigning entitlements to users finishes';
export const FILE_HEADERS = {
    userId: 'User Id',
    email: 'Email',
    role: 'Role',
    resources: 'Resources',
    grantName: 'Grant Name',
    actionStatus: 'Action Status',
};
